import { useContext } from 'react';
import { ContainerWidthContext } from '../lib/ContainerWidthContext';

// Drop-in replacement for react-responsive's useMediaQuery, aliased at bundle
// time.
//
// In the iframe renderers useMediaQuery reads the iframe viewport, which is
// always the embed container width. Without an iframe we must NOT read the
// host window - a wall dropped into a narrow column should still go to its
// mobile/tablet layout. So this resolves { minWidth, maxWidth } queries
// against the .famewall-embed container width supplied via context.
//
// The Wall-Embeds renderers only ever pass the object form
// ({ maxWidth }, { minWidth, maxWidth }); width-only queries are all that is
// needed for parity.
export function useMediaQuery(query) {
  const containerWidth = useContext(ContainerWidthContext);
  const width =
    containerWidth || (typeof window !== 'undefined' ? window.innerWidth : 1024);

  if (!query || typeof query !== 'object') {
    return false;
  }

  let matches = true;

  if (query.minWidth !== undefined) {
    matches = matches && width >= parseInt(query.minWidth, 10);
  }

  if (query.maxWidth !== undefined) {
    matches = matches && width <= parseInt(query.maxWidth, 10);
  }

  return matches;
}

export default { useMediaQuery };
